import type { BuildingFinishesSections } from "../../../types/buildings-sections/finishes";

export const finishes: BuildingFinishesSections = {
  title: "Viimistlused",
  description: "Hoone viimistluste info",
  noDataAvailable: "Viimistluste andmed puuduvad",
  material: "Materjal",
  color: "Värv",
  manufacturer: "Tootja",
  installationDate: "Paigalduskuupäev",
  durabilityRating: "Vastupidavuse hinnang",
  warrantyInfo: "Garantii info",
  maintenanceRequirements: "Hoolduse nõuded",
  noFinishes: "Viimistlused puuduvad",
  addFinish: "Lisa viimistlus",
  editFinish: "Muuda viimistlust",
  deleteFinish: "Kustuta viimistlus",
  floorings: "Põrandad",
  walls: "Seinad",
  ceilings: "Laed",
  doors: "Uksed",
  windows: "Aknad",
  other: "Muud viimistlused",
};
